"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WETH = void 0;
const types_1 = require("../types");
exports.WETH = {
    [types_1.Networks.Ropsten]: '0xc778417E063141139Fce010982780140Aa0cD5Ab',
    [types_1.Networks.Mainnet]: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    [types_1.Networks.Polygon]: '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270',
    [types_1.Networks.Arbitrum]: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
    [types_1.Networks.Avalanche]: '0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7',
    //[Networks.Moonriver]: '0xf50225a84382c74cbdea10b0c176f71fc3de0c4d', // WMOVR
    [types_1.Networks.Moonriver]: '0x98878b06940ae243284ca214f92bb71a2b032b8a',
    [types_1.Networks.Aurora]: '0xC9BdeEd33CD01541e1eeD10f90519d2C06Fe3feB',
    [types_1.Networks.Cronos]: '0x5c7f8a570d578ed84e63fdfa7b1ee72deae1ae23',
    [types_1.Networks.Fantom]: '0x21be370d5312f44cb42ce377bc9b8a0cef1a4c83',
    [types_1.Networks.Harmony]: '0xcf664087a5bb0237a0bad6742852ec6c8d69a27a',
    [types_1.Networks.Moonbeam]: '0xacc15dc74880c9944775448304b263d191c6077f',
    [types_1.Networks.Sxnetwork]: '0xacc15dc74880c9944775448304b263d191c6077f',
    [types_1.Networks.Canto]: '0x826551890Dc65655a0Aceca109aB11AbDbD7a07B',
    [types_1.Networks.ZksyncEra]: '0x5AEa5775959fBC2557Cc8789bC1bf90A239D9a91',
    [types_1.Networks.Blast]: '0x4300000000000000000000000000000000000004',
    [types_1.Networks.Base]: '0x4200000000000000000000000000000000000006',
    [types_1.Networks.Mantle]: '0x78c1b0C915c4FAA5FffA6CAbf0219DA63d7f4cb8',
    [types_1.Networks.Scroll]: '0x5300000000000000000000000000000000000004',
    [types_1.Networks.Optimism]: '0x4200000000000000000000000000000000000006',
    [types_1.Networks.Real]: '0x90c6E93849E06EC7478ba24522329d14A5954Df4',
    [types_1.Networks.Sonic]: '0x039e2fB66102314Ce7b64Ce5Ce3E5183bc94aD38',
    [types_1.Networks.Linea]: '0xe5D7C2a44FfDDf6b295A15c148167daaAf5Cf34f', // weth
};
